import styles from "./products.module.css";
import Product from "./Product/Product";
import { HeadingTitle, SwiperSlider } from "../../shared/index";
import { SwiperSlide } from "swiper/react";
const Products = ({
  title,
  products,
  variant = "slider",
  wishItems = [],
  isWishListPending,
  imageOnly = false,
  lastItemRef,
  hidePrice = false,
  sliderType = "default",
}) => {
  const safeId = title?.replace(/\s+/g, "-").toLowerCase();
  return (
  <section className={styles.products__wrapper}>

  {/* SECTION HEADER */}
  <div className={styles.sectionHeader}>
    <h2 className={styles.heading}>
      {title}
    </h2>

 
  </div>

  {variant === "slider" ? (
      <SwiperSlider
  prevId={`${safeId}-prev`}
  nextId={`${safeId}-next`}
  wrapperClass={`${styles.productsSlider} ${
    sliderType === "recommendation"
      ? styles.recommendationSlider
      : ""
  }`}
  prevBtnClass={`${styles.navButton} ${styles.prevButton} ${
    sliderType === "recommendation"
      ? styles.recommendationNavButton
      : ""
  }`}
  nextBtnClass={`${styles.navButton} ${styles.nextButton} ${
    sliderType === "recommendation"
      ? styles.recommendationNavButton
      : ""
  }`}
  centeredSlides={false}
  slidesPerView={1}
  spaceBetween={12}
  breakpoints={{
    480: {
      slidesPerView: 2,
      spaceBetween: 14,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 18,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  }}
>
       {products?.map((product) => (
  <SwiperSlide key={product.id}>
    <Product
      product={product}
      wishItems={wishItems}
      isWishListPending={isWishListPending}
      hidePrice={hidePrice}
    />
  </SwiperSlide>
))}
        </SwiperSlider>
      ) : ( 
        
        <div className={styles.productsGrid}>
          {products?.map((p,index) => (
           <Product
  product={p}
  key={p.id}
  wishItems={wishItems}
  isWishListPending={isWishListPending}
  imageOnly={imageOnly}
  ref={index === products.length - 1 ? lastItemRef : null}
/>
          ))}
        </div>
      )}
    </section>
  );
};
export default Products;